import App from './components/config/App'
import { createRoot } from 'react-dom/client';
import AppErrorBoundary from './components/global/Error/AppErrorBoundary';


const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(<AppErrorBoundary><App /></AppErrorBoundary>);
